<template>
  <div id="goodsInfo">
    <!-- <div class="mainTitle">商品管理</div> -->
    <el-card v-auth="'/goodsInfo/pageList'">
      <el-form
        ref="searchForm"
        :model="searchForm"
        :label-width="formLabelWidth"
      >
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="4">
            <!-- <el-input type="number" v-model="searchForm.courseId" auto-complete="off"></el-input> -->
            <el-cascader
              style="width: 100%"
              clearable
              collapse-tags
              v-model="courseIds"
              :show-all-levels="false"
              :props="subjectTreeProps"
              placeholder="请输入所属科目"
              :options="subjectTreeList"
              @change="subjectSearchChange"
            ></el-cascader>
          </el-col>
          <el-col :sm="24" :md="12" :lg="4" v-if="activeName == 'first'">
            <el-input
              v-model="searchForm.name"
              placeholder="请输入商品名称"
              auto-complete="off"
              clearable
            ></el-input>
          </el-col>
          <el-col :sm="24" :md="12" :lg="4" v-else>
            <el-input
              v-model="searchForm.seriesName"
              placeholder="请输入系列课名称"
              auto-complete="off"
              clearable
            ></el-input>
          </el-col>
          <el-col :sm="24" :md="12" :lg="4">
            <!-- <el-radio v-model="searchForm.sell" label="1">上架</el-radio>
            <el-radio v-model="searchForm.sell" label="0">下架</el-radio>-->
            <el-select v-model="searchForm.sell" style="width: 100%">
              <el-option label="全部" value></el-option>
              <el-option label="上架" value="1"></el-option>
              <el-option label="下架" value="-1"></el-option>
            </el-select>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-date-picker
              style="width: 100%"
              v-model="createTime"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              @change="timeChange"
            ></el-date-picker>
          </el-col>
          <el-col :sm="24" :md="6" :lg="6" style="float: right">
            <div style="float: right">
              <!-- <a class="mainColor" @click="reset">重置</a> -->
              <el-button
                type="primary"
                @click="(page.pageNumber = 1), pageList()"
                v-auth="'/goodsInfo/pageList'"
                icon="el-icon-search"
                >查询</el-button
              >
            </div>
          </el-col>
        </el-row>
        <!-- <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="12" style="float:right">
            <div style="float:right">
              <a class="mainColor" @click="reset">重置</a>
              <el-button type="primary" @click="pageList" icon="el-icon-search">查询</el-button>
            </div>
          </el-col>
        </el-row>-->
      </el-form>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          :label="item.label"
          :name="item.name"
          v-for="(item, k) in catogeryList"
          :key="k"
        >
        </el-tab-pane>
      </el-tabs>
      <el-row :gutter="20">
        <div
          class
          style="
            float: left;
            font-weight: bolder;
            line-height: 40px;
            color: #4e4e4e;
            margin-left: 10px;
          "
          :key="page.total"
        >
          商品数量 ：{{ page.total }}
        </div>
        <el-col :sm="24" :md="12" :lg="12" style="float: right">
          <el-button-group style="float: right">
            <!-- <el-button type="primary" @click="addGoods(0)" icon="el-icon-plus">添加题库商品</el-button>
            <el-button type="primary" @click="addGoods(1)" icon="el-icon-plus">添加套餐商品</el-button>-->
            <el-button
              type="primary"
              @click="goToCommodityCenter()"
              v-auth="'/goodsInfo/goToCommodityCenter'"
              icon="el-icon-plus"
              v-if="activeName == 'first'"
              >去商品库</el-button
            >
            <el-button
              type="primary"
              @click="addGoods(1)"
              v-auth="'/goodsInfo/addGoods'"
              icon="el-icon-plus"
              >{{
                activeName == "first" ? "自建商品" : "添加系列课"
              }}</el-button
            >
            <el-button
              type="primary"
              @click="goodsBatchOff"
              v-auth="'/goodsInfo/goodsBatchOff'"
              >批量下架</el-button
            >
            <el-button
              type="primary"
              @click="goodsBatchOn"
              v-auth="'/goodsInfo/goodsBatchOn'"
              >批量上架</el-button
            >
            <!-- <el-button type="danger" @click="batchDeleteGoodsInfo" icon="el-icon-minus">批量删除</el-button> -->
          </el-button-group>
        </el-col>
      </el-row>
      <el-table
        :key="'goodsManageTable'"
        v-if="activeName == 'first' && !loading"
        ref="multipleTable"
        :data="page.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%"
        border
        @selection-change="selectionChange"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
      >
        <el-table-column type="selection" min-width="40"></el-table-column>

        <el-table-column
          show-overflow-tooltip
          prop="sell"
          label="上架"
          align="center"
          width="80px"
        >
          <template slot-scope="row">
            <el-switch
              v-model="row.row.sell"
              active-value="1"
              inactive-value="-1"
              @change="updateSwitching(row)"
              class="switchStyle"
              active-text="开"
              inactive-text="关"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column
          prop="id"
          show-overflow-tooltip
          label="商品id"
          width="180px"
        ></el-table-column>

        <el-table-column
          prop="name"
          label="商品"
          show-overflow-tooltip
          width="260px"
        >
          <template slot-scope="row">
            <div style="display: flex">
              <img
                style="width: 120px; height: 60px"
                :src="
                  row.row.logo
                    ? row.row.logo
                    : 'http://ncszhgj.oss-cn-hangzhou.aliyuncs.com/tkwx/15743276279534477403800.png'
                "
              />
              <div style="margin-left: 10px; width: 130px">
                <!-- <span style="color:rgb(106,224,105)" v-if="row.row.recommend=='1'">{{"[推荐]"}}</span>
                <span style="color:rgb(106,224,105)" v-if="row.row.hot=='1'">{{"[热门]"}}</span>-->
                <!-- <span style="color:rgb(77,145,225)">{{row.row.name}}</span> -->
                <span>{{ row.row.name }}</span>
                <span style="display: block">
                  <span style="color: red">￥{{ row.row.price }}</span>
                  <span
                    style="
                      text-decoration: line-through;
                      color: rgb(162, 170, 188);
                    "
                    >￥{{ row.row.originalPrice }}</span
                  >
                </span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="validDay"
          align="center"
          show-overflow-tooltip
          label="有效期"
          width="130px"
        >
          <template slot-scope="row">{{
            row.row.validDay ? row.row.validDay + "天" : "不限"
          }}</template>
        </el-table-column>
        <!-- <el-table-column prop="postponeDay" label="延期天数" min-width="8%">
          <template slot-scope="row">{{row.row.postponeDay==""?"-":row.row.postponeDay}}天</template>
        </el-table-column>-->
        <el-table-column
          prop="subjectCourseName"
          show-overflow-tooltip
          label="所属科目"
          width="160px"
        ></el-table-column>
        <el-table-column
          prop="type"
          label="类型"
          show-overflow-tooltip
          :render-header="renderSpecNameHeader"
          width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-tooltip
              :content="scope.row.type"
              placement="top"
              effect="light"
            >
              <div
                style="
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                "
              >
                {{ scope.row.type }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="60px"
          align="center"
          prop="goodsItemCount"
          label="内容"
        >
          <template slot-scope="row">
            <el-button @click="goodsItem(row.row)" type="text">{{
              row.row.goodsItemCount
            }}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="60px"
          align="center"
          prop="clazzCount"
          label="排班"
        >
          <template slot-scope="row">
            <el-button @click="classItem(row.row)" type="text">{{
              row.row.clazzCount
            }}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="90px"
          align="center"
          prop="flashSaleType"
          label="是否限购"
          :render-header="renderLimitType"
        >
          <template slot-scope="row">
            <span>{{ row.row.flashSaleType == "1" ? "是" : "否" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="60px"
          align="center"
          prop="snapPrice"
          label="限购价格"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="160px"
          align="center"
          prop="startTime"
          label="限购开始时间"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="160px"
          align="center"
          prop="stopTime"
          label="限购结束时间"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="sellCount"
          label="真实销量"
          align="center"
          width="80px"
        >
          <template slot-scope="row">
            <!-- <span>{{row.row.actualSellCount}}</span> -->
            <el-button @click="goodsNumber(row.row.id)" type="text"
              >{{
                row.row.actualSellCount == null ? 0 : row.row.actualSellCount
              }}
            </el-button>
            <!-- <el-button
              @click="goodsNumber(row.row.id)"
              type="text"
            >{{row.row.stock==null?0:row.row.stock}}</el-button> -->
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="validDay"
          label="上架时间"
          width="200px"
          align="center"
        >
          <template slot-scope="row">{{ row.row.onTime }}</template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="validDay"
          label="失效时间"
          width="200px"
          align="center"
        >
          <template slot-scope="row">
            <span v-if="row.row.offTime == null">不限</span>
            <span v-else>不限</span>
          </template>
        </el-table-column>
        <!-- <el-table-column min-width="14%" prop="tags" label="标签">
          <template slot-scope="row">
            <span v-for=" (item,index) in row.row.tags" :key="index">
              <el-tag type="info" style="margin-right:4px;">{{row.row.tags[index]}}</el-tag>
            </span>
          </template>
        </el-table-column>-->
        <el-table-column
          show-overflow-tooltip
          prop="addWay"
          label="添加路径"
          width="200px"
          align="center"
        >
          <template slot-scope="row">
            <span v-if="row.row.addWay == 1">商品库</span>
            <span v-if="row.row.addWay == 2">自建</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          show-overflow-tooltip
          label="操作"
          align="center"
          width="220"
        >
          <template slot-scope="scope">
            <div class="operationGroup" style="z-index: 100">
              <i
                class="el-icon-edit icon-style"
                title="编辑"
                @click="editGoods(scope.row)"
                v-auth="'/goodsInfo/editGoods'"
              ></i>
              <!-- <i class="el-icon-delete icon-style" title="删除" @click="deleteGoodsInfo(scope.row)"></i> -->
              <i
                class="el-icon-view mainColor"
                style="font-size: 20px"
                title="查看"
                v-auth="'/goodsInfo/goGoodsInfo'"
                @click="goGoodsInfo(scope.row)"
              ></i>
              <span
                style="color: #409eff"
                @click="deleteGoodsInfo(scope.row)"
                v-auth="'/goodsInfo/deleteGoodsInfo'"
                >删除</span
              >
              <span
                style="color: #409eff"
                @click="copyGoodsInfo(scope.row)"
                v-auth="'/goodsInfo/copyGoodsInfo'"
                >复制</span
              >
              <span
                style="color: #409eff"
                @click="getGoodsClaimCode(scope.row)"
                v-auth="'/goodsInfo/getGoodsClaimCode'"
              >兑换码</span
              >
              <!-- <i class="iconfont icon-qian mainColor" title="代理价" @click="openEdit(scope.row)"></i> -->
              <!-- <span @click="editGoods(scope.row.id)">编辑</span>
              <span @click="deleteGoodsInfo(scope.row)">删除</span>
              <span @click="goodsAgentPrice(scope.row.id)">代理价</span>-->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 系列课************************************************* -->
      <el-table
        :key="'seriesGoods'"
        v-if="activeName == 'second' && !loading"
        ref="multipleTableS"
        :data="page.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%"
        border
        @selection-change="selectionChange"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
      >
        <el-table-column type="selection" min-width="40"></el-table-column>
        <el-table-column prop="seriesName" show-overflow-tooltip label="系列名称" minwidth="160px"></el-table-column>
        <el-table-column prop="subjectCourseName" show-overflow-tooltip label="所属科目" minwidth="160px"></el-table-column>
        <el-table-column show-overflow-tooltip minwidth="80px" align="center" prop="goodsCount" label="关联商品">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="sell"
          label="状态"
          align="center"
          minwidth="80px"
        >
          <template slot-scope="row">
            <el-switch
              v-model="row.row.sell"
              active-value="1"
              inactive-value="-1"
              @change="updateSwitching(row)"
              class="switchStyle"
              active-text="开"
              inactive-text="关"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column
          prop="agentSellCount"
          show-overflow-tooltip
          label="机构销量"
          minwidth="160px"
        ></el-table-column>
        <el-table-column
          prop="operator"
          v-if="false"
          label="创建人"
          minwidth="160px"
        ></el-table-column>
        <el-table-column
          prop="operator"
          label="创建人"
          minwidth="160px"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          minwidth="160px"
        ></el-table-column>
        <el-table-column
          fixed="right"
          show-overflow-tooltip
          label="操作"
          align="center"
          width="220"
        >
          <template slot-scope="scope">
            <div class="operationGroup" style="z-index: 100">
              <i
                class="el-icon-edit icon-style"
                title="编辑"
                @click="editGoods(scope.row)"
                v-auth="'/goodsInfo/editGoods'"
              ></i>
              <span
                style="color: #409eff"
                @click="deleteGoodsInfo(scope.row)"
                v-auth="'/goodsInfo/deleteGoodsInfo'"
                >删除</span
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 30, 40]"
        style="margin-top: 20px; text-align: right"
        :key="page.total"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>
    <el-dialog
      title="编辑商品"
      :visible.sync="editGoodsVisible"
      width="650px"
      left
      :close-on-click-modal="false"
    >
      <el-form
        ref="editForm"
        :model="editForm"
        :label-width="formLabelWidth"
        :rules="editFormRules"
      >
        <el-form-item label="原价" prop="originalPrice">
          <el-input
            type="number"
            min="0"
            v-model="editForm.originalPrice"
            placeholder="请输入原价(RMB)"
            auto-complete="off"
            @change="originalPriceChange"
            maxlength="10"
          ></el-input>
        </el-form-item>
        <el-form-item label="上传封面" prop="img">
          <div class="uploadCoverOfGoods">
            <el-upload
              style="display: flex"
              class="avatar-uploader-logo"
              action
              :show-file-list="false"
              ref="upload"
              :http-request="posterUploadRequest"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <img
                class="currencySetting-image"
                style="margin-left: 20px"
                v-if="editForm.img"
                :src="editForm.img"
                height="60"
                width="60"
              />
            </el-upload>
            <div class="paySetting-tips">
              至少上传1张，最多上传3张，JPG、PNG格式，每张图片不超过2M,第一张为主图，可拖动图片进行排序，建议尺寸750*560px或4：3
            </div>
          </div>
        </el-form-item>
        <el-form-item label="上传视频" prop="videoUrl" v-loading="loadVideo">
          <div>
            <el-upload
              class="avatar-uploader-logo"
              action
              :show-file-list="false"
              ref="upload"
              :http-request="videoUrlUploadRequest1"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <video
                class="currencySetting-image"
                style="margin-left: 20px"
                v-if="editForm.videoUrl"
                :src="editForm.videoUrl"
                height="60"
                width="108"
              ></video>
            </el-upload>
            <div class="paySetting-tips">
              支持mp4、avi、wmv格式，大小不超过2GB
            </div>
          </div>
        </el-form-item>
        <el-form-item label="折后价" prop="price">
          <el-input
            type="number"
            min="0"
            v-model="editForm.price"
            placeholder="请输入折后价"
            auto-complete="off"
            maxlength="10"
          >
            <template slot="append">
              <el-select
                style="width: 90px"
                v-model="discount"
                @change="discountChange()"
                :disabled="editForm.free == '1'"
                :placeholder="placeholderdiscount"
              >
                <el-option
                  v-for="(item, index) in discountOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="显示销量" prop="sellCount">
          <el-input
            type="number"
            min="0"
            v-model="editForm.sellCount"
            placeholder="请输入显示销量"
            auto-complete="off"
            maxlength="10"
          ></el-input>
        </el-form-item>
        <el-form-item label="限时抢购" prop="flashSaleType">
          <el-radio v-model="editForm.flashSaleType" :label="1">是</el-radio>
          <el-radio v-model="editForm.flashSaleType" :label="-1">否</el-radio>
        </el-form-item>
        <el-form-item label="限时抢购价" prop="snapPrice">
          <el-input
            type="number"
            min="0"
            v-model="editForm.snapPrice"
            placeholder="请输入限时抢购价(RMB)"
            auto-complete="off"
            maxlength="10"
          ></el-input>
        </el-form-item>
        <el-form-item label="限购时间" prop="purchaseDateRange">
          <el-date-picker
            style="width: 100%"
            v-model="purchaseDateRange"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            @change="editGoodsDateRangeChange"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="商品介绍" prop="detail">
          <div style="background: #fff">
            <UE
              name="1"
              :value="editForm.detail"
              ref="myQuillEditorTitle"
              :key="editGoodsVisible"
            ></UE>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="editGoodsVisible = false">取 消</el-button>
        <el-button type="primary" @click="addGoodsInfo">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="设置代理价"
      :visible.sync="agentPriceVisible"
      width="450px"
      left
    >
      <el-table :data="tableData" style="width: 100%">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column
          prop="name"
          label="代理类型"
          width="180"
        ></el-table-column>
        <el-table-column prop="price" label="代理价（元）" width="180">
          <template slot-scope="row">
            <el-input
              v-model="row.row.price"
              placeholder="请输入代理价格"
            ></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="agentPriceVisible = false">取 消</el-button>
        <el-button type="primary" @click="addGoodsAgentPriceBatch"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="编辑代理价"
      :visible.sync="editVisible"
      width="400px"
      left
    >
      <el-form :label-width="formLabelWidth" v-if="editForms.length > 0">
        <el-row :span="24">
          <div class="zhao-center">
            <div
              style="
                color: #455a64;
                font-weight: bold;
                font-size: 14px;
                width: 50%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              "
            >
              商品名:{{ editFormsList.name }}
            </div>
            <div
              style="
                color: #455a64;
                font-weight: bold;
                font-size: 14px;
                text-align: right;
                width: 50%;
              "
            >
              商品价格:{{ editFormsList.price }}
            </div>
          </div>
        </el-row>
        <el-row :span="24" style="margin: 10px 0">
          <el-col :sm="6" :md="6" :lg="6">
            <div>代理等级</div>
          </el-col>
          <el-col :sm="9" :md="9" :lg="9">
            <div>代理价格</div>
          </el-col>
        </el-row>
        <div v-if="editForms != null && editForms.length > 0">
          <el-row :span="24" v-for="(item, index) in editForms" :key="index">
            <div
              class="zhao-center"
              style="justify-content: space-between; margin-bottom: 10px"
            >
              <div
                class="zhao-center"
                :style="`width:20%;height:32px;color:#fff;background-color: ${item.color}`"
              >
                {{ item.name }}
              </div>
              <el-input
                style="width: 76%"
                size="small"
                v-model="item.price"
                placeholder
              >
                <template slot="append">
                  <span class="mainColor">元</span>
                </template>
              </el-input>
            </div>
          </el-row>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="editVisible = false">取 消</el-button>
        <el-button type="primary" @click="closeDialog2">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SelectHeader from "./SelectHeader";
import dropCell from "./dropCell.vue";
import { uploadOSS } from "../../upload/upload";
import UE from "../conmom/CKEditorInformation.vue";
import { createdCourse,deletedCourse,updatedCourse } from '../../api/es-search'
export default {

  components: { UE },
  data() {
    var valiSnapPrice = (rule, value, callback) => {
      if (value === "") {
        callback();
      } else {
        if (this.editForm.snapPrice > this.editForm.originalPrice) {
          callback(new Error("限时抢购不能大于原价"));
        }
      }
      callback();
    };
    return {
      activeName: "first",
      catogeryList: [
        {
          label: "非系列课",
          name: "first",
        },
        {
          label: "系列课",
          name: "second",
        },
      ],
      purchaseDateRange: "",
      tableData: [],
      editForms: [],
      addgoodsAgentPrice: {},
      editGoodsVisible: false,
      agentPriceVisible: false,
      editVisible: false,
      subjectTreeList: [], //科目
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
        multiple: true,
      },
      page: {
        rows: [],
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      addFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      createTime: "",
      courseIds: [],
      searchForm: {
        sell: "",
        flashSaleType: "",
        subjectIds: [],
        onTimeBegin: "",
        onTimeEnd: "",
        name: "",
      },
      editFormsList: {},
      addForm: {
        name: "",
        logo: "",
        recommend: "",
        hot: "",
        sell: "",
        validDay: "",
        tags: "",
        courseId: "",
        postpone: "",
        postponeDay: "",
        sellCount: "",
        price: "",
        originalPrice: "",
        summary: "",
        detail: "",
      },

      placeholderdiscount: "",
      discount: "",
      discountOptions: [
        {
          value: "1",
          label: "不打折",
        },
        {
          value: "0.9",
          label: "9折",
        },
        {
          value: "0.8",
          label: "8折",
        },

        {
          value: "0.7",
          label: "7折",
        },
        {
          value: "0.6",
          label: "6折",
        },
        {
          value: "0.5",
          label: "5折",
        },
        {
          value: "0.4",
          label: "4折",
        },
        {
          value: "0.3",
          label: "3折",
        },
        {
          value: "0.2",
          label: "2折",
        },
        {
          value: "0.1",
          label: "1折",
        },
      ],
      addFormRules: {
        name: [
          {
            required: true,
            message: "请输入商品名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 100,
            message: "商品名称长度在1到100个字",
          },
        ],
        logo: [
          {
            required: true,
            message: "请输入图标",
            trigger: "blur",
          },
          {
            min: 1,
            max: 300,
            message: "图标长度在1到300个字",
          },
        ],
        recommend: [
          {
            required: true,
            message: "请输入是否推荐",
            trigger: "blur",
          },
          {
            pattern:
              /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "是否推荐格式不正确",
          },
        ],
        hot: [
          {
            required: true,
            message: "请输入是否热门",
            trigger: "blur",
          },
          {
            pattern:
              /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "是否热门格式不正确",
          },
        ],
        sell: [
          {
            required: true,
            message: "请输入是否上架",
            trigger: "blur",
          },
          {
            pattern:
              /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "是否上架格式不正确",
          },
        ],
        validDay: [
          {
            required: true,
            message: "请输入有效天数",
            trigger: "blur",
          },
          {
            pattern:
              /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "有效天数格式不正确",
          },
        ],
        tags: [
          {
            required: true,
            message: "请输入标签",
            trigger: "blur",
          },
          {
            min: 1,
            max: 1000,
            message: "标签长度在1到1000个字",
          },
        ],
        courseId: [
          {
            required: true,
            message: "请输入科目id-第二级分类",
            trigger: "blur",
          },
          {
            pattern:
              /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "科目id-第二级分类格式不正确",
          },
        ],
        postpone: [
          {
            required: true,
            message: "请输入是否支持延期",
            trigger: "blur",
          },
          {
            pattern:
              /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "是否支持延期格式不正确",
          },
        ],
        postponeDay: [
          {
            required: true,
            message: "请输入延期天数",
            trigger: "blur",
          },
          {
            pattern:
              /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "延期天数格式不正确",
          },
        ],
        sellCount: [
          {
            required: true,
            message: "请输入销量",
            trigger: "blur",
          },
          {
            pattern:
              /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "销量格式不正确",
          },
        ],
        price: [
          {
            required: true,
            message: "请输入价格",
            trigger: "blur",
          },
          {
            pattern:
              /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "价格格式不正确",
          },
        ],
        originalPrice: [
          {
            required: true,
            message: "请输入原始价格",
            trigger: "blur",
          },
          {
            pattern:
              /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "原始价格格式不正确",
          },
        ],
        summary: [
          {
            required: true,
            message: "请输入摘要",
            trigger: "blur",
          },
          {
            min: 1,
            max: 1000,
            message: "摘要长度在1到1000个字",
          },
        ],
        detail: [
          {
            required: true,
            message: "请输入详细介绍",
            trigger: "blur",
          },
          {
            min: 1,
            max: 65535,
            message: "详细介绍长度在1到65535个字",
          },
        ],
      },
      editForm: {
        flashSaleType: "-1",
        name: "",
        logo: "",
        recommend: "",
        hot: "",
        sell: "",
        validDay: "",
        tags: "",
        videoUrl: "",
        courseId: "",
        postpone: "",
        postponeDay: "",
        price: "",
        originalPrice: "",
        summary: "",
        detail: "",
        stopTime: "",
        startTime: "",
        sellCount: "",
        img: "",
      },
      editFormRules: {
        name: [
          {
            required: true,
            message: "请输入商品名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 100,
            message: "商品名称长度在1到100个字",
          },
        ],

        recommend: [
          {
            required: true,
            message: "请输入是否推荐",
            trigger: "blur",
          },
          {
            pattern:
              /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "是否推荐格式不正确",
          },
        ],
        hot: [
          {
            required: true,
            message: "请输入是否热门",
            trigger: "blur",
          },
          {
            pattern:
              /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "是否热门格式不正确",
          },
        ],
        sell: [
          {
            required: true,
            message: "请输入是否上架",
            trigger: "blur",
          },
          {
            pattern:
              /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "是否上架格式不正确",
          },
        ],
        validDay: [
          {
            required: true,
            message: "请输入有效天数",
            trigger: "blur",
          },
          {
            pattern:
              /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "有效天数格式不正确",
          },
        ],
        tags: [
          {
            required: true,
            message: "请输入标签",
            trigger: "blur",
          },
          {
            min: 1,
            max: 1000,
            message: "标签长度在1到1000个字",
          },
        ],
        courseId: [
          {
            required: true,
            message: "请输入科目id-第二级分类",
            trigger: "blur",
          },
          {
            pattern:
              /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "科目id-第二级分类格式不正确",
          },
        ],
        postpone: [
          {
            required: true,
            message: "请输入是否支持延期",
            trigger: "blur",
          },
          {
            pattern:
              /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "是否支持延期格式不正确",
          },
        ],
        postponeDay: [
          {
            required: true,
            message: "请输入延期天数",
            trigger: "blur",
          },
          {
            pattern:
              /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "延期天数格式不正确",
          },
        ],
        price: [
          {
            required: true,
            message: "请输入价格",
            trigger: "blur",
          },
          {
            pattern:
              /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "价格格式不正确",
          },
        ],
        flashSaleType: [
          {
            required: true,
            message: "请选择是否抢购",
            trigger: "blur",
          },
        ],
        originalPrice: [
          {
            required: true,
            message: "请输入原始价格",
            trigger: "blur",
          },
          {
            pattern:
              /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "原始价格格式不正确",
          },
        ],
        summary: [
          {
            required: true,
            message: "请输入摘要",
            trigger: "blur",
          },
          {
            min: 1,
            max: 1000,
            message: "摘要长度在1到1000个字",
          },
        ],
        detail: [
          {
            required: true,
            message: "请输入详细介绍",
            trigger: "blur",
          },
          {
            min: 1,
            max: 65535,
            message: "详细介绍长度在1到65535个字",
          },
        ],
        snapPrice: [{ validator: valiSnapPrice, trigger: "blur" }],
      },
      importForm: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      fileAction: `${process.env.BASE_URL}/goodsInfo/upload`,
      fileList: [],
      loading: true,
      updatePageId: "",
      goodsId: "",
      updatePageGoodsItem: "",
      loadVideo: false,
    };
  },
  methods: {
    handleClick(va) {
      console.log(this.activeName);
      this.page.pageNumber = 1;
      this.pageList();
    },
    posterUploadRequest(file) {
      console.log("file", file);
      const isJPG =
        file.file.type === "image/jpeg" || file.file.type === "image/png";
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/png 格式!");
        return;
      }
      if (file.file.size / 1024 / 1024 > 1) {
        this.$message.error("图片大小不能超过1M");
        return;
      } else {
        uploadOSS(file, "generalSetting").then((result) => {
          this.$set(this.editForm, "img", result);
        });
      }
    },
    openEdit(item) {
      this.editVisible = true;
      this.editFormsList = item;
      this.goodsId = item.id;
      this.api.agentLevel
        .getAgentPriceByGoodsId({ goodsId: item.id })
        .then((result) => {
          if (result.success) {
            this.editForms = result.data;
            this.editForms.forEach((items) => {
              if (items.goodsAgentPrice == null) {
                this.$set(items, "price", null);
              } else {
                this.$set(items, "price", items.goodsAgentPrice.price);
              }
            });
          } else {
            this.$message.error(result.message);
          }
        });
    },
    closeDialog2() {
      let obj = [];
      // console.log("this.editForms",this.editForms)
      this.editForms.forEach((item) => {
        if (
          item.goodsAgentPrice == null ||
          item.goodsAgentPrice == "undefined"
        ) {
          if (item.price == null) {
            obj.push({
              goodsId: this.goodsId,
              agentLevelId: item.id,
            });
          } else {
            obj.push({
              goodsId: this.goodsId,
              agentLevelId: item.id,
              price: item.price.toString(),
            });
          }
        } else {
          if (item.price == null || item.price == "") {
            obj.push({
              id: item.goodsAgentPrice.id,
              agentLevelId: item.id,
              goodsId: this.goodsId,
            });
          } else {
            obj.push({
              id: item.goodsAgentPrice.id,
              goodsId: this.goodsId,
              agentLevelId: item.id,
              price: item.price.toString(),
            });
          }
        }
      });
      this.api.goodsAgentPrice
        .updateGoodsAgentPriceByBatch(obj)
        .then((result) => {
          if (result.success) {
            this.editVisible = false;
            this.pageList();
            this.$message.success(result.message);
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    goGoodsInfo(row) {
      this.$router.push({
        path: "/goGoodsInfo",
        query: {
          id: row.id,
        },
      });
    },
    goodsItem (row) {
      this.updatePageGoodsItem = row.id;
      if (row.type == "系列课") {
        this.$router.push({
          path: "/bindGoodsByBatch",
          query: {
            updatePageGoodsItem: this.updatePageGoodsItem,
            subjectId: row.subjectId,
            goodsId: row.copyGoodsInfoId,
            addWay: row.addWay,
          },
        });
      } else {
        this.$router.push({
          path: "/goodsItems",
          query: {
            updatePageGoodsItem: this.updatePageGoodsItem,
            subjectId: row.subjectId,
            goodsId: row.copyGoodsInfoId,
            addWay: row.addWay,
          },
        });
      }
    },

    classItem(row) {
      this.updatePageGoodsItem = row.id;
      this.$router.push({
        path: "/goodsSchedule",
        query: {
          updatePageGoodsItem: this.updatePageGoodsItem,
          subjectId: row.subjectId,
          goodsId: row.copyGoodsInfoId,
          addWay: row.addWay,
        },
      });
    },
    goodsNumber(row) {
      this.$router.push({
        path: "/goodsNumber",
        query: { goodsId: row },
      });
    },
    getAgentLevelList() {
      this.tableData = [];
      this.api.goodsAgentPrice.getAgentLevelList().then((result) => {
        this.tableData = result.data;
        for (let i in result.data) {
          delete this.tableData[i].createTime;
          delete this.tableData[i].enabled;
          delete this.tableData[i].grade;
          delete this.tableData[i].logo;
          delete this.tableData[i].remark;
          delete this.tableData[i].state;
          delete this.tableData[i].updateTime;
        }
      });
    },
    goodsAgentPrice(vId) {
      this.goodsId = vId;

      this.tableData = [];
      this.api.goodsAgentPrice.getAgentLevelList().then((result) => {
        this.tableData = result.data;
        for (let i in result.data) {
          delete this.tableData[i].createTime;
          delete this.tableData[i].enabled;
          delete this.tableData[i].grade;
          delete this.tableData[i].logo;
          delete this.tableData[i].remark;
          delete this.tableData[i].state;
          delete this.tableData[i].updateTime;
        }
        this.api.goodsAgentPrice
          .getGoodsAgentPriceList({ goodsId: vId })
          .then((result) => {
            for (let i in result.data) {
              for (let item in this.tableData) {
                if (result.data[i].agentLevelId == this.tableData[item].id) {
                  //this.tableData[item].price = result.data[i].price;
                  this.$set(
                    this.tableData[item],
                    "price",
                    result.data[i].price
                  );
                }
              }
            }
            // console.log("this.tableData", this.tableData);
            this.agentPriceVisible = true;
          });
      });
    },
    addGoodsAgentPriceBatch() {
      for (let i in this.tableData) {
        this.tableData[i].goodsId = this.goodsId;
        this.tableData[i].agentLevelId = this.tableData[i].id;
        delete this.tableData[i].id;
        delete this.tableData[i].name;
      }
      this.api.goodsAgentPrice
        .addGoodsAgentPriceBatch(this.tableData)
        .then((result) => {
          if (result.success) {
            this.agentPriceVisible = false;
            this.$message.success(result.message);
            this.pageList();
          } else {
            this.$message.error(result.message);
          }
        });
    },
    editGoods(row) {
      if (this.activeName == "first") {
        if (row.addWay == 1) {
          this.discount = "";
          this.purchaseDateRange = [];
          this.api.goodsInfo.getGoodsInfo({ id: row.id }).then((result) => {
            result.data.free = result.data.free.toString();
            this.editForm = result.data;
            this.purchaseDateRange = result.data.startTime
              ? [result.data.startTime, result.data.stopTime]
              : "";
            this.placeholderdiscount =
              (this.editForm.price / this.editForm.originalPrice).toFixed(2) *
                10 +
              "折";
            this.editGoodsVisible = true;
          });
        } else {
          this.updatePageId = row.id;
          this.$router.push({
            path: "/editGoodsTaocan",
            query: {
              updatePageId: this.updatePageId,
            },
          });
        }
      } else {
        this.updatePageId = row.id;
        this.$router.push({
          path: "/addSeriesGoods",
          query: {
            updatePageId: this.updatePageId,
          },
        });
      }
    },

    discountChange() {
      this.checked = false;
      this.editForm.price = parseInt(
        (this.discount ? this.discount : 1) * this.editForm.originalPrice
      );
    },
    originalPriceChange() {
      if (this.editForm.free == "1") {
      } else {
        this.editForm.price = this.editForm.originalPrice;
        this.discountChange();
      }
    },
    renderLimitType(createElement, { column, $index }) {
      let self = this;
      console.log("renderLimitType", createElement, { column, $index });
      return createElement(
        "div",
        {
          style: "display:flex;padding:0px",
        },
        [
          createElement("div", {
            domProps: {
              innerHTML: column.label,
            },
          }),
          createElement(dropCell, {
            style: "cursor: pointer;",
            // 组件 prop
            // 事件监听器在 `on` 属性内，
            // 但不再支持如 `v-on:keyup.enter` 这样的修饰器。
            // 需要在处理函数中手动检查 keyCode。
            on: {
              selectChange: self.cellChange,
              // click: this.clickHandler
            },
            // 仅用于组件，用于监听原生事件，而不是组件内部使用
            // `vm.$emit` 触发的事件。
            nativeOn: {
              click: this.cellChange,
            },
          }),
        ]
      );
    },
    renderSpecNameHeader(createElement, { column, $index }) {
      let self = this;

      return createElement(
        "div",
        {
          style: "display:flex;padding:0px",
        },
        [
          createElement("div", {
            domProps: {
              innerHTML: column.label,
            },
          }),
          createElement(SelectHeader, {
            style: "cursor: pointer;",
            // 组件 prop
            props: {
              type: "specId",
              options: self.specIdOptions, //下拉框选项
              defaultValue: self.specId, //默认值
              defaultProps: {
                value: "specId",
                label: "specName",
              },
            },
            // 事件监听器在 `on` 属性内，
            // 但不再支持如 `v-on:keyup.enter` 这样的修饰器。
            // 需要在处理函数中手动检查 keyCode。
            on: {
              selectChange: self.selectChange,
              // click: this.clickHandler
            },
            // 仅用于组件，用于监听原生事件，而不是组件内部使用
            // `vm.$emit` 触发的事件。
            nativeOn: {
              // click: this.nativeClickHandler
            },
          }),
        ]
      );
    },
    cellChange(val) {
      console.log(val, val.constructor, "cellChange");
      if (val.constructor == String) {
        this.searchForm.flashSaleType = val;
        this.pageList();
      }
      //写点啥吧
    },
    //选择框回调
    selectChange(val) {
      console.log("selectChange", val);
      this.searchForm.type = val;
      this.pageList();
      //写点啥吧
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      console.log(property, row[property] === value);
      return row[property] === value;
    },
    timeChange() {
      if (this.createTime) {
        this.searchForm.onTimeBegin = this.createTime[0];
        this.searchForm.onTimeEnd = this.createTime[1];
      } else {
        this.searchForm.onTimeBegin = "";
        this.searchForm.onTimeEnd = "";
      }
    },
    editGoodsDateRangeChange() {
      if (this.purchaseDateRange) {
        this.editForm.startTime = this.purchaseDateRange[0];
        this.editForm.stopTime = this.purchaseDateRange[1];
      } else {
        this.editForm.startTime = "";
        this.editForm.stopTime = "";
      }
    },
    subjectSearchChange() {
      if (this.courseIds) {
        this.searchForm.subjectIds = [];
        this.courseIds.forEach((item) => {
          this.searchForm.subjectIds.push(item[1]);
        });
      } else {
        this.searchForm.subjectIds = [];
      }
      // console.log(this.searchForm.subjectIds);
    },
    getSubjectTreeList() {
      // 获取课程
      this.api.campus
        .getPermissionSubjectTree()
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                delete items.children;

                // if (items.children.length != 0) {
                //   for (let itemss of items.children) {
                //     delete itemss.children;
                //   }
                // } else {
                //   // delete items.children;
                // }
              }
            } else {
              // delete item.children;
            }
          }

          this.subjectTreeList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addGoods(sty) {
      if (this.activeName == "second") {
        this.$router.push({
          path: "/addSeriesGoods?type=add",
        });
      } else {
        if (sty) {
          this.$router.push({
            path: "/addGoodsTaocan",
          });
        } else {
          this.$router.push({
            path: "/addGoodsTiku",
          });
        }
      }
    },
    goToCommodityCenter(sty) {
      this.$router.push({
        path: "/commodityCenter",
      });
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange(val) {
      this.ids = [];
      this.multipleSelection = val;
      val.map((e) => this.ids.push(e.id));
    },
    //获取数据
    getGoodsInfo() {
      this.api.goodsInfo
        .getGoodsInfo({
          id: this.$route.query.updatePage,
        })
        .then((result) => {
          this.editForm = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    goodsBatchOn() {
      if (!this.ids.length) {
        this.$message({
          type: "error",
          message: "请选择需要上架的商品",
        });
        return;
      }
      let apiName = "";
      if (this.activeName == 'first') {
        apiName = "goodsBatchOn";
      } else {
        apiName = 'seriesGoodsBatchOn'
      }
      this.api.goodsInfo[apiName]({ idList: this.ids }).then((result) => {
        if (result.success) {
          this.$message({
            type: "success",
            message: result.message,
          });
            createdCourse(this.ids).then(res=>{ console.log(1); })

          this.pageList();
        } else {
          this.$message({
            type: "error",
            message: result.message,
          });
          this.pageList();
        }
      })
    },
    goodsBatchOff() {
      if (!this.ids.length) {
        this.$message({
          type: "error",
          message: "请选择需要下架的商品",
        });
        return;
      }
      let apiName = "";
      if (this.activeName == 'first') {
        apiName = "goodsBatchOff";
      } else {
        apiName = 'seriesGoodsBatchOff'
      }
      this.api.goodsInfo[apiName]({ idList: this.ids }).then((result) => {
        if (result.success) {
          this.$message({
            type: "success",
            message: result.message,
          });
            deletedCourse(this.ids).then(res=>{ console.log(1); })

          this.pageList();
        } else {
          this.$message({
            type: "error",
            message: result.message,
          });
          this.pageList();
        }
      })
    },
    pageList(val) {
      // if (typeof val == "string") {
      //   this.searchForm.type = val;
      // } else {
      //   this.searchForm.type = "";
      // }
      this.loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      let apiName = "";
      let params = {};
      if (this.activeName == "first") {
        apiName = "pageList";
        params = this.searchForm;
      } else {
        apiName = "seriesGoodsPageList";
        params = {
          pageSize: this.page.pageSize,
          pageNumber: this.page.pageNumber,
          seriesName: this.searchForm.seriesName,
          subjectIds: this.searchForm.subjectIds,
          createTimeBegin: this.searchForm.onTimeBegin,
          createTimeEnd: this.searchForm.onTimeEnd,
        };
      }

      this.api.goodsInfo[apiName](params).then((result) => {
        this.page.rows = result.data.records;
        this.loading = false;
        for (let i in this.page.rows) {
          this.page.rows[i].sell = String(this.page.rows[i].sell);
        }
        this.page.total = result.data.total;
        console.log(this.page.total);
        this.loading = false;
      });
    },

    addGoodsInfo() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editForm.detail = this.$refs.myQuillEditorTitle._data.content;
          this.api.goodsInfo
            .updateGoodsInfo(this.editForm)
            .then((result) => {
              if (result.success) {
                this.editGoodsVisible = false;
                updatedCourse(this.editForm.id).then(res=>{console.log(res)})
                this.editForm = {};
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateSwitching(row) {
      // console.log(row.row.sell);
      this.ids[0] = row.row.id;
      if (row.row.sell == 1) {
        this.goodsBatchOn();
      } else {
        this.goodsBatchOff();
      }
    },
    updateGoodsInfo() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.api.goodsInfo
            .updateGoodsInfo(this.editForm)
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    copyGoodsInfo(row) {
      this.$confirm("确定要复制该商品吗?", "系统消息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.api.goodsInfo
          .copyGoodsInfo({
            goodsId: row.id,
          })
          .then((result) => {
            if (result.success) {
              this.$message({
                type: "success",
                message: result.message,
              });
              this.pageList();
            } else {
              this.$message.error(result.message);
            }
          });
      });
    },
    getGoodsClaimCode(row) {
      this.$router.push({
        path: "/goodsClaimCode",
        query: {
          goodsClaimCodeFormGoodsId: row.id
        },
      });
    },
    deleteGoodsInfo(row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      }).then(() => {
        let apiName = "";
        if (this.activeName == 'first') {
          apiName = "deleteGoodsInfo";
        } else {
          apiName = 'deleteSeriesGoods'
        }
        this.api.goodsInfo[apiName]([{ id: row.id, },]).then((result) => {
          if (result.success) {
            this.$message({
              type: "success",
              message: result.message,
            });
                deletedCourse([row.id]).then(res=>{ console.log(1); })

            this.pageList();
          } else {
            this.$message.error(result.message);
          }
        })
      })
    },
    batchDeleteGoodsInfo() {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.api.goodsInfo
            .deleteGoodsInfo(this.ids)
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    reset() {
      this.loading = true;
      this.$refs.searchForm.resetFields();
      this.createTime = [];
      this.courseIds = [];
      this.searchForm = {
        sell: "1",
        subjectIds: [],
        onTimeBegin: "",
        onTimeEnd: "",
        name: "",
      };
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      };
      this.pageList();
    },
    handleSuccess(response, file, fileList, $event) {
      this.importForm = response.data;
    },
    exportExcel() {
      this.loading = true;
      this.api.goodsInfo
        .exportExcel(this.searchForm)
        .then((result) => {
          location.href = result.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    importData() {
      this.api.goodsInfo
        .importData(this.importForm.rows)
        .then((result) => {
          this.$message({
            type: "success",
            message: result.message,
          });
          this.pageList();
          this.importFormVisible = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    videoUrlUploadRequest1(file) {
      this.loadVideo = true;
      console.log("file", file);
      const isJPG =
        file.file.type === "video/mp4" ||
        file.file.type === "video/avi" ||
        file.file.type === "video/wmv";
      if (!isJPG) {
        this.$message.error("上传视频只支持mp4、avi、wmv格式!");
        return;
      }
      if (file.file.size / 1024 / 1024 > 2000) {
        this.$message.error("视频大小不能超过2G");
        return;
      } else {
        uploadOSS(file, "generalSetting").then((result) => {
          this.$set(this.editForm, "videoUrl", result);
          this.loadVideo = false;
        });
      }
    },
  },
  computed: {
    reqData() {
      return this.$store.state.user;
    },
  },
  activated() {
    this.pageList();
  },
  watch: {
    addFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.pageList();
      } else {
      }
    },
    editFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.getGoodsInfo();
      }
    },
  },
  mounted () {
    this.activeName == this.$route.query.backtoseries ? 'second' : 'first'
    this.pageList();
    this.getSubjectTreeList();
  },
};
</script>
<style lang="less">
#goodsInfo {
  .switchStyle .el-switch__label--right.is-active {
    span {
      margin-right: 32px;
    }
  }
}
</style>
<style lang="less" scoped>
.avatar-uploader-logo {
  margin-top: 20px;
}

.uploadCoverOfGoods .avatar-uploader-logo .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
}

.avatar-uploader-logo .el-upload:hover {
  border-color: #409eff;
}

.uploadCoverOfGoods .el-upload {
  display: flex !important;
}

.uploadCoverOfGoods .avatar-uploader-icon {
  display: flex !important;
  justify-content: center;
  font-size: 28px;
  float: left;
  color: #8c939d;
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
}

.currencySetting-image {
  float: left;
}

.avatar {
  width: 60px;
  height: 60px;
  display: block;
}

.paySetting-tips {
  white-space: initial !important;
  word-break: break-all !important;
}

.avatar-uploader-logo {
  margin-top: 20px;
}

.avatar-uploader-logo .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-logo .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
}

.avatar {
  width: 60px;
  height: 60px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/goods/index.vue